export default "__VITE_ASSET__DO2TP7PB__"